import React from 'react';
import { formatCurrencyCompact } from '../../utils/formatters';

export function ChannelRevenuePivot({ channelMonthlyRevenue }) {
  if (!channelMonthlyRevenue?.rows?.length) {
    return <p className="text-xs text-gray-400 text-center py-4">No channel revenue data available</p>;
  }

  const { headers, rows, totals } = channelMonthlyRevenue;
  const channels = headers.filter(h => h !== 'Month');

  return (
    <div className="overflow-x-auto">
      <table className="modern-table">
        <thead>
          <tr>
            <th className="text-left">Month</th>
            {channels.map(ch => (
              <th key={ch} className="text-right">{ch}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              <td className="text-xs font-medium text-gray-700">{row.month}</td>
              {channels.map(ch => (
                <td key={ch} className="text-right text-xs font-medium">
                  {formatCurrencyCompact(row[ch]?.revenue || 0)}
                </td>
              ))}
            </tr>
          ))}
          {/* Totals row */}
          <tr className="font-bold bg-gray-50/50">
            <td className="text-xs font-bold text-gray-800">Total</td>
            {channels.map(ch => (
              <td key={ch} className="text-right text-xs font-bold text-gray-800">
                {formatCurrencyCompact(totals?.[ch]?.revenue || 0)}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
